import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jsmAssetsSchemas: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.assets-menu.schemas.jsm-assets-schemas',
		defaultMessage: 'Schemas',
		description: 'Assets dropdown item to link customer to Schemas page.',
	},
});
